import { SetStateAction, useState } from "react";
import EstablishmentNodeCreate from "./EstablishmentNodeCreate";
import EstablishmentNodeView from "./EstablishmentNodeView";
import EstablishmentNodeEdit from "./EstablishmentNodeEdit";

const EstablishmentNodeIndex = ({
  index,
  isActive,
  mode,
  nextButtonFunction,
  toggleEdit,
  establishmentID,
  closeWizard,
  updateInterfaceData,
  interfaceData
}: EstablishmentNodeIndexProps) => {

  const [isEstablishmentNodeInit, setIsEstablishmentNodeInit] = useState(mode === "edit" ? true : false);
  
  return (
    <>
      {mode === "create" && isActive &&
        <EstablishmentNodeCreate
        nextButtonFunction={nextButtonFunction}
        setIsEstablishmentNodeInit={setIsEstablishmentNodeInit} 
        updateInterfaceData={updateInterfaceData}        />
      }

      {mode === "edit" && isActive && 
        <EstablishmentNodeEdit 
        nextButtonFunction={nextButtonFunction}
        establishmentID={establishmentID}
        interfaceData={interfaceData} 
        setIsEstablishmentNodeInit={setIsEstablishmentNodeInit} 
        updateInterfaceData={updateInterfaceData}        />
      } 

      {isEstablishmentNodeInit && !isActive &&
        <EstablishmentNodeView 
        toggleEdit={toggleEdit}
        userID={establishmentID}
        closeWizard={closeWizard} 
        interfaceData={interfaceData}        />
      }  
    </>
  )
}

export default EstablishmentNodeIndex;

type EstablishmentNodeIndexProps = {
  isActive: boolean;
  nextButtonFunction: () => void;
  index: number;
  toggleEdit: () => void;
  mode: "create" | "edit";
  establishmentID?: number;
  closeWizard: () => void;
  updateInterfaceData: (data: Partial<IEstablishmentInterfaceForm>) => void;
  interfaceData: IEstablishmentInterfaceForm
}